import { render } from "./ChangeLangComponent.vue?vue&type=template&id=572c28b1&scoped=true"
import script from "./ChangeLangComponent.vue?vue&type=script&lang=js"
export * from "./ChangeLangComponent.vue?vue&type=script&lang=js"

import "./ChangeLangComponent.vue?vue&type=style&index=0&id=572c28b1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572c28b1"]])

export default __exports__